import { ReactNode } from 'react';

import { ChakraProvider, SystemContext } from '@chakra-ui/react';

import { CacheProvider } from '@emotion/react';

// Direct module import: the theme barrel would also build the unused esi/wc/app-preview systems on the client
import raspberrySsrTheme from '@nocowanie/common-ui/theme/raspberry-theme/ssr.theme';

import { useEmotionCache } from '@app/hooks/useEmotionCache';

export const ThemeProviderWithCache = ({
    theme,
    children,
}: {
    theme?: SystemContext;
    children: ReactNode;
}): ReactNode => {
    const { cache } = useEmotionCache();

    return (
        <CacheProvider value={cache}>
            <ChakraProvider value={theme ?? raspberrySsrTheme}>{children}</ChakraProvider>
        </CacheProvider>
    );
};
